import React from 'react';
import TitleSection from "../../../../../../components/Atomes/Title/TitleSection";
import ButtonWithOnClickAction from "../../../../../../components/Atomes/Buttons/ButtonWithOnClickAction";

const KpisViewTitle = ({onClick}) => {

	return (
        <div className={"section-kpi-title"}>
			<TitleSection title={"Indicateurs de performance"}/>
			<ButtonWithOnClickAction onClick={onClick} title={"Exporter"} isActive={true} styleButton={"btn-default btn-default-blue btn-download color-primary"}/>
		</div>
    )

}
export default KpisViewTitle;